module.exports = __webpack_public_path__ + "static/media/doctor3.ef59f70b.jpg";